import { css } from '@emotion/react';
import t from 'react-translate';
import { useContext } from 'react';
import NvIcon from 'shared/components/nv-icon';
import moment from 'moment';
import ClickableContainer from 'components/clickable-container';
import { config } from '@config/pendo.config.json';
import { gray5 } from 'styles/global_defaults/colors';
import AiConversationContext from '../context';
import useViewedSubmission from '../use-viewed-submission';

const styles = css`
 .termination-status {
    min-height: 50px;
    border: 1px solid ${gray5};
    border-radius: 15px;
 }
`;
const VoiceTerminatedStatus = () => {
  const { handleStartVoiceConversation } = useContext(AiConversationContext);

  const {
    isCurrentUserSubmission,
    viewedSubmission: submission,
  } = useViewedSubmission();

  return (
    <div css={styles} className='mt-6 pb-4 d-flex flex-column align-items-center justify-content-center'>
      {submission?.finishedAt && (
        <p className='font-weight-normal mb-0'>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.SESSION_ENDED_ON(moment(submission.finishedAt).format('LLL'))}
        </p>
      )}
      <div className='termination-status mt-4 bg-white py-3 px-4 d-flex align-items-center'>
        <NvIcon
          icon='warning'
          className='text-danger d-flex align-items-center'
          size='small'
        />
        <p className='mb-0 ml-2 font-weight-bold text-gray-1'>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.ROLE_PLAY_ENDED_DUE_TO_INACTIVITY()}
        </p>
        {isCurrentUserSubmission && (
        <ClickableContainer
          className='text-primary ml-1 text-regular font-weight-bold'
          onClick={handleStartVoiceConversation}
          data-qa={config.pendo.activities.aiRolePlay.conversationModal.startOver}
        >
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.START_OVER()}
        </ClickableContainer>
        )}
      </div>
    </div>
  );
};

export default VoiceTerminatedStatus;
